import {
  createClient,
  fetchExchange,
  ssrExchange,
} from '@urql/vue';
import { devtoolsExchange } from '@urql/devtools';

export const ssr = ssrExchange({ isClient: import.meta.client });

const getWaiverClient = (domain: string) => createClient({
  url: `${domain}/v2/graphql/waiver`,
  preferGetMethod: false,
  fetchOptions: () => ({
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Cache: 'no-cache',
    },
    credentials: 'include',
  }),
  exchanges: [
    devtoolsExchange,
    ssr, // Add `ssr` in front of the `fetchExchange`
    fetchExchange,
  ],
});

export default getWaiverClient;
